import dayjs from 'dayjs';
import { useCreateEventTicketTemplateMutation } from 'services/eventTickets';
import { EventTicket } from 'components/passes/eventTicket';
import { EventTicketInputs } from 'types';
import { createTemplateComponent } from 'components/reusable/template';


const initialData = {
  owner: undefined,
  allow_anonymous: false,
  verbose_name: '',
  description: '',
  app_launch_url: null,
  associated_store_identifiers: null,
  max_distance: 999,
  background_color: "#ffffff",
  foreground_color: "#000000",
  label_color: "#000000",
  expiration_date: dayjs(),
  relevant_date: dayjs(),
  logo_text: '',
  header_fields: [],
  back_fields: [],
  secondary_fields: [],
  auxiliary_fields: [],
  ibeacons: [],
  locations: [],
  barcodes: [],
  primary_field: undefined,
  logo_image: undefined,
  icon_image: undefined,
  strip_image: undefined,
  thumbnail_image: undefined,
  background_image: undefined,
}

export const CreateEventTicketTemplate = createTemplateComponent<EventTicketInputs>({
  initialData: initialData,
  TemplateRenderer: EventTicket,
  i18nNamespace: "pass",
  successBaseUrl: "/event-tickets/",
  createTemplateHook: useCreateEventTicketTemplateMutation,
})